/**
 * Define a custom element if it is not already defined.
 * @param name The custom element name for the component
 * @param component The component to assign to the name
 */
export function declareComponent(name: string, component: CustomElementConstructor) {
   if (globalThis.customElements && !globalThis?.customElements?.get(name)) {
      globalThis.customElements.define(name, component);
   }
}
